import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarjtotilinga() {



  const cardData =
  {
    keyword: 'Pune to Bhimashankar Jyotirlinga bus on Rent ',
    heading: 'Sanavi Travels: Pune to Bhimashankar Jyotirlinga bus on Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Bhimashankar Jyotirlinga Bus on Rent, providing safe, comfortable, and well-organized transportation solutions for pilgrims, families, senior citizens, religious groups, and tour operators traveling from Pune to the sacred Bhimashankar Jyotirlinga. Our fleet includes AC and Non-AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, all well-maintained with spacious seating, adequate legroom, and ample luggage space to ensure a smooth and peaceful pilgrimage journey. With experienced ghat-route drivers, flexible one-day and overnight rental packages, transparent pricing, and punctual service, Sanavi Travels guarantees a safe and timely travel experience. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering Bhimashankar Jyotirlinga Temple and nearby forest and hill areas. Choose Sanavi Travels for trusted Pune to Bhimashankar Jyotirlinga bus rental services, ensuring comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Bhimashankar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhimashankar Temple",
    "description": "Bhimashankar Temple is a sacred Jyotirlinga shrine dedicated to Lord Shiva, nestled in the Sahyadri hills of Maharashtra. Surrounded by dense forests and misty mountains, the temple is a spiritual haven and an important pilgrimage site. Its historic architecture and serene surroundings attract devotees and tourists alike. Bhimashankar represents devotion, tranquility, and natural beauty."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary, encompassing lush forests and rugged terrain, is home to the endangered Indian Giant Squirrel (Shekru) and diverse flora and fauna. Trekking, birdwatching, and nature walks are popular activities. The sanctuary offers a pristine natural environment, blending adventure with conservation. It showcases the ecological richness of the Western Ghats."
  },
  {
    "title": "Kushalgarh Waterfall",
    "description": "Kushalgarh Waterfall is a scenic waterfall located near Bhimashankar, ideal for nature lovers and photographers. Surrounded by dense greenery, the cascading waters create a tranquil ambiance. The monsoon season enhances its beauty, attracting visitors seeking serenity and adventure."
  },
  {
    "title": "Vajreshwari Hill Trek",
    "description": "Vajreshwari Hill Trek near Bhimashankar is popular among trekking enthusiasts and nature explorers. The trail offers breathtaking views of the Western Ghats, dense forests, and cascading streams. The trek provides a combination of adventure, fitness, and scenic beauty."
  },
  {
    "title": "Bhimashankar River",
    "description": "The Bhima River originates near the Bhimashankar Temple, flowing through picturesque valleys and forested landscapes. It is a sacred river for pilgrims and a natural attraction for nature lovers. The river enhances the spiritual and scenic charm of the region."
  },
  {
    "title": "Pawna Dam",
    "description": "Pawna Dam is located near Bhimashankar and is a popular spot for picnics, camping, and photography. The reservoir is surrounded by hills and forests, providing a serene and refreshing environment. Visitors enjoy boating and sunset views here."
  },
  {
    "title": "Naneghat Pass",
    "description": "Naneghat is an ancient mountain pass connecting the Konkan coast to the Deccan plateau, close to Bhimashankar. It features historic trade routes, natural springs, and trekking trails. The pass offers panoramic views of valleys, waterfalls, and dense forests. Naneghat reflects the historical and natural significance of the region."
  },
  {
    "title": "Saptashrungi Hills",
    "description": "Saptashrungi Hills, located near Bhimashankar, are famous for the Saptashrungi Devi Temple and scenic vistas. The hills are surrounded by lush forests and are a significant spiritual destination. Visitors can trek or drive to explore the natural beauty and religious importance of the area."
  },
  {
    "title": "Chandoli National Park",
    "description": "Chandoli National Park, in proximity to Bhimashankar, is part of the Western Ghats biodiversity hotspot. It houses a variety of wildlife including leopards, deer, and exotic bird species. The park offers trekking, camping, and wildlife photography opportunities. Chandoli emphasizes the ecological richness of the region."
  },
  {
    "title": "Kalsubai Peak",
    "description": "Kalsubai Peak, Maharashtra’s highest point, is located near Bhimashankar. The trek to the summit is popular among adventure enthusiasts and offers panoramic views of the Sahyadri ranges. The area is especially beautiful during the monsoon, surrounded by waterfalls and misty landscapes. Kalsubai Peak combines adventure, nature, and breathtaking scenery."
  }
]
,




"services": [
  {
    "name": "Pune to Bhimashankar Jyotirlinga bus on Rent",
    "description": "Pune to Bhimashankar Jyotirlinga bus on Rent offers reliable and comfortable buses for devotees traveling from Pune to Bhimashankar. Ideal for group pilgrimages, family trips, or religious tours, these buses provide spacious seating, luggage space, and professional drivers ensuring a safe and smooth journey. Flexible booking options and well-maintained vehicles make visiting the sacred Jyotirlinga convenient, stress-free, and enjoyable for all travelers."
  },
  {
    "name": "Bhimashankar Bus Hire Pune",
    "description": "Bhimashankar Bus Hire Pune provides private and group bus rental services for trips from Pune to Bhimashankar. Equipped with comfortable seating and safety features, these buses are perfect for families, friends, or corporate groups seeking a hassle-free journey. Experienced drivers manage the route efficiently, making the trip to Bhimashankar smooth, safe, and convenient."
  },
  {
    "name": "AC Bus Pune to Bhimashankar",
    "description": "AC Bus Pune to Bhimashankar offers air-conditioned buses for a cool and comfortable ride to the sacred Bhimashankar Jyotirlinga. Ideal for long-distance travel, these buses provide spacious interiors, smooth rides, and reliable service. Passengers can enjoy the journey in comfort while ensuring safety and punctual arrivals."
  },
  {
    "name": "Luxury Bhimashankar Tour Bus",
    "description": "Luxury Bhimashankar Tour Bus provides premium, well-appointed buses for a stylish and comfortable pilgrimage to Bhimashankar. Equipped with reclining seats, entertainment options, and ample luggage space, these buses cater to VIP groups, corporate outings, or family tours seeking a high-end travel experience."
  },
  {
    "name": "Family Bhimashankar Bus Trip",
    "description": "Family Bhimashankar Bus Trip ensures safe and comfortable travel for families visiting Bhimashankar Jyotirlinga. With child-friendly features, luggage space, and reliable drivers, this service prioritizes family convenience and comfort, making one-day pilgrimages or weekend trips hassle-free and enjoyable."
  },
  {
    "name": "Group Travel Bhimashankar Bus",
    "description": "Group Travel Bhimashankar Bus is designed for large groups, friends, school trips, or corporate outings to Bhimashankar. Spacious buses, professional drivers, and organized pick-up/drop-off arrangements make group travel stress-free, safe, and enjoyable."
  },
  {
    "name": "Affordable Bhimashankar Bus Hire",
    "description": "Affordable Bhimashankar Bus Hire offers budget-friendly travel options for groups or families traveling to Bhimashankar Jyotirlinga. Well-maintained buses, professional drivers, and flexible booking options ensure a comfortable journey without compromising on safety or convenience."
  },
  {
    "name": "Chauffeur Driven Bhimashankar Bus",
    "description": "Chauffeur Driven Bhimashankar Bus provides experienced drivers for a relaxed, hassle-free journey from Pune to Bhimashankar. Passengers can sit back while professional chauffeurs handle routes, traffic, and safety, making the pilgrimage stress-free and convenient."
  },
  {
    "name": "Best Bhimashankar Tour Bus Pune",
    "description": "Best Bhimashankar Tour Bus Pune offers top-quality buses and professional service for a superior pilgrimage experience. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure a smooth, safe, and enjoyable journey for families, friends, and corporate groups."
  },
  {
    "name": "Pune Bhimashankar Travel Bus",
    "description": "Pune Bhimashankar Travel Bus provides dependable and comfortable buses for trips between Pune and Bhimashankar Jyotirlinga. Spacious interiors, luggage-friendly seating, and professional chauffeurs ensure smooth, safe, and hassle-free travel for tourists, devotees, and pilgrimage groups."
  },
  {
    "name": "Religious Tour Bus Pune",
    "description": "Religious Tour Bus Pune specializes in transporting devotees from Pune to Bhimashankar for spiritual tours. Well-maintained buses, professional drivers, and organized itineraries ensure safe, convenient, and comfortable travel for all participants."
  },
  {
    "name": "Jyotirlinga Darshan Bus Pune",
    "description": "Jyotirlinga Darshan Bus Pune offers dedicated buses for pilgrims visiting Bhimashankar Jyotirlinga. Spacious seating, luggage-friendly interiors, and skilled drivers make the journey smooth, safe, and enjoyable, allowing devotees to focus on their spiritual experience."
  },
  {
    "name": "Pilgrimage Bus Hire Pune",
    "description": "Pilgrimage Bus Hire Pune provides buses specifically for religious journeys from Pune to Bhimashankar. Comfortable, reliable, and well-equipped buses ensure safe and convenient travel for groups, families, and devotees planning a sacred trip."
  },
  {
    "name": "Temple Tour Bus Pune",
    "description": "Temple Tour Bus Pune offers organized bus travel for devotees visiting Bhimashankar and nearby temples. With comfortable seating, professional drivers, and flexible pick-up/drop-off options, this service ensures a smooth, safe, and enjoyable temple tour experience."
  }
],
"tableData": [
  ["Pune to Bhimashankar Jyotirlinga bus on Rent", "Bhimashankar Bus Hire Pune"],
  ["AC Bus Pune to Bhimashankar", "Luxury Bhimashankar Tour Bus"],
  ["Family Bhimashankar Bus Trip", "Group Travel Bhimashankar Bus"],
  ["Affordable Bhimashankar Bus Hire", "Chauffeur Driven Bhimashankar Bus"],
  ["Best Bhimashankar Tour Bus Pune", "Pune Bhimashankar Travel Bus"],
  ["Religious Tour Bus Pune", "Jyotirlinga Darshan Bus Pune"],
  ["Pilgrimage Bus Hire Pune", "Temple Tour Bus Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Bhimashankar Jyotirlinga Bus on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable bus rental services from Pune to Bhimashankar Jyotirlinga, perfect for group pilgrimages, family trips, school outings, and spiritual journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses with ample seating and luggage space for a smooth and enjoyable journey to Bhimashankar Jyotirlinga."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune–Bhimashankar Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Bhimashankar route, ensuring safe, punctual, and hassle-free travel for all passengers."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Bhimashankar Jyotirlinga bus rentals, including fuel, tolls, and driver allowances for a stress-free booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel planning, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental plans tailored to your Pune to Bhimashankar Jyotirlinga travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Bhimashankar Jyotirlinga bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Bhimashankar Jyotirlinga bus on rent?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained buses for travel from Pune to Bhimashankar Jyotirlinga.'
  },
  {
    question: 'How can I book a bus from Pune to Bhimashankar Jyotirlinga with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are available for Pune to Bhimashankar travel?',
    answer: 'We provide air-conditioned and non-AC buses in various seating capacities suitable for group travel.'
  },
  {
    question: 'Are drivers included in the bus rental?',
    answer: 'Yes, all rentals include experienced and professional drivers familiar with Pune to Bhimashankar routes.'
  },
  {
    question: 'Is the Pune to Bhimashankar Jyotirlinga bus service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Bhimashankar bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Bhimashankar trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Shashank More',
    feedback: 'Booked a Pune to Bhimashankar Jyotirlinga bus with Sanavi Travels. Comfortable ride and excellent service made our pilgrimage memorable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shruti Kulkarni',
    feedback: 'Very good experience! Clean bus, on-time pickup, and smooth journey to Bhimashankar Jyotirlinga. Highly recommend Sanavi Travels.',
    rating: 5
  }
];



































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Jyotirlinga Bus on Rent - Sanavi Travels",
  "description": "Hire Pune to Bhimashankar Jyotirlinga bus on rent with Sanavi Travels. AC and luxury buses for religious tours, Jyotirlinga darshan, family temple visits, group pilgrimages, and comfortable chauffeur-driven travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};









  return (
    <div>

<Helmet>
  <title>
    Pune to Bhimashankar Jyotirlinga Bus on Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury buses from Pune to Bhimashankar Jyotirlinga with Sanavi Travels. Best choice for religious tours, pilgrimage trips, Jyotirlinga darshan, family temple visits, and group travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarjtotilinga;